import { useLocation, useNavigate } from "react-router-dom";
import { useUserType } from "../../hooks/useUserType";
import { useAnalytics } from "../../lib/analytics";
import { useClientTranslations } from "../../lib/i18n/client";
import styles from "./UpperNav.module.css";

const NAV_ITEMS = [
	{
		key: "insights",
		icon: "/images/home/home-top-nav/insights-icon.svg",
		route: "/",
		activeClassName: "navIconContainerActive",
	},
	{
		key: "files",
		icon: "/images/home/home-top-nav/files-icon.svg",
		route: "/files",
		activeClassName: "navIconContainerActiveFiles",
	},
	{
		key: "prepare",
		icon: "/images/home/home-top-nav/prepare-icon.svg",
		route: "/get-ready",
		activeClassName: "navIconContainerActiveGetReady",
	},
	{
		key: "track",
		icon: "/images/home/home-top-nav/track-icon.svg",
		route: "/track",
		activeClassName: "navIconContainerActiveTrack",
	},
	{
		key: "share",
		icon: "/images/home/home-top-nav/share-icon.svg",
		route: "/share",
		activeClassName: "navIconContainerActiveShare",
	},
] as const;

export function UpperNav() {
	const { t } = useClientTranslations("common");
	const { isD2C } = useUserType();
	const location = useLocation();
	const navigate = useNavigate();
	const { logNav } = useAnalytics();

	const handleNavClick = (key: string, route: string) => {
		const navigated = location.pathname !== route;
		logNav("item_clicked", {
			bar: "top",
			item: key,
			destination: route,
			from: location.pathname,
			// false = tapped the already-active item (no navigation occurred).
			navigated,
		});
		if (navigated) {
			navigate(route);
		}
	};

	return (
		<div className={styles.container}>
			<nav className={styles.nav} data-testid="top-nav">
				{NAV_ITEMS.filter((item) => !(isD2C && item.key === "share")).map(
					(item) => {
						const isJourneyRoute =
							location.pathname === "/journey" ||
							location.pathname.startsWith("/journey/");
						const isActive = isJourneyRoute
							? false
							: item.route === "/"
								? location.pathname === "/"
								: location.pathname === item.route ||
									location.pathname.startsWith(`${item.route}/`) ||
									(item.route === "/get-ready" &&
										location.pathname === "/questionnaire");
						return (
							<button
								key={item.key}
								type="button"
								className={styles.navItem}
								onClick={() => handleNavClick(item.key, item.route)}
								aria-label={t(`home.nav.${item.key}`)}
								aria-current={isActive ? "page" : undefined}
							>
								<div
									className={`${styles.navIconContainer}${isActive ? ` ${styles[item.activeClassName]}` : ""}`}
								>
									<img
										src={item.icon}
										alt={t(`home.nav.${item.key}`)}
										className={isActive ? styles.navIconActive : styles.navIcon}
									/>
								</div>
								<span className={styles.navLabel}>
									{t(`home.nav.${item.key}`)}
								</span>
							</button>
						);
					},
				)}
			</nav>
		</div>
	);
}
